import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CspondemandComponent } from './cspondemand.component';
import { CspondemandNavigationComponent } from './cspondemand-navigation/cspondemand-navigation.component';
import { CspondemandRoutingModule } from './cspondemand-routing.module';
import { RouterModule } from '@angular/router';
import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from 'src/app/shared/material-module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CspondemandRoutingModule,
    CoreModule,
    MaterialModule
  ],
  declarations: [
    CspondemandComponent,
    CspondemandNavigationComponent
  ]
})
export class CspondemandModule { }
